import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {modifypasswd,modifypasswdByAdmin} = api


/**
 * 修改密码
 */
export async function updateModifypasswd(params) {
    return request({url: modifypasswd, method: 'post', data: params,})
}
export async function updateModifypasswdByAdmin(params) {
    return request({url: modifypasswdByAdmin, method: 'post', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/userPwd.js